import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import type {
  IGenerateNewHireFileUrlApiResponse,
  IGenerateNewHireFileUrlRequest,
} from "./generateNewHireFileUrl.schema";

export const generateNewHireFileUrl = (axios: IAxiosInstance) => {
  return async (
    params: IGenerateNewHireFileUrlRequest
  ): Promise<IGenerateNewHireFileUrlApiResponse> => {
    const response =
      await axios.noRetry.get<IGenerateNewHireFileUrlApiResponse>(
        `/api/new-hire-reporting/files/${params.record_id}/url`
      );
    return response.data;
  };
};
